import React from "react";

// Inner SVG paths (stroke = currentColor) for each solution concept.
export const featureIcons: Record<string, React.ReactNode> = {
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18" />
    </>
  ),
  building: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="1.5" />
      <path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2" />
    </>
  ),
  rocket: (
    <>
      <path d="M12 15l-3-3c1-6 4-9 9-9c0 5-3 8-9 9z" />
      <path d="M9 12c-2 .5-3 2-3 5c3 0 4.5-1 5-3" />
      <circle cx="14.5" cy="9.5" r="1.4" />
    </>
  ),
  cart: (
    <>
      <circle cx="9" cy="20" r="1.5" />
      <circle cx="17" cy="20" r="1.5" />
      <path d="M3 4h2l2.4 12h10l2-8H6.5" />
    </>
  ),
  sparkleAI: (
    <>
      <rect x="6" y="6" width="12" height="12" rx="2.5" />
      <circle cx="12" cy="12" r="2" />
      <path d="M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3" />
    </>
  ),
  mobile: (
    <>
      <rect x="7" y="3" width="10" height="18" rx="2.5" />
      <path d="M11 18h2" />
    </>
  ),
  warehouse: (
    <>
      <path d="M3 21V8l9-4 9 4v13" />
      <path d="M7 21v-7h10v7" />
    </>
  ),
  box: (
    <>
      <path d="M12 3 4 7v10l8 4 8-4V7z" />
      <path d="M4 7l8 4 8-4M12 11v10" />
    </>
  ),
  truck: (
    <>
      <path d="M3 6h11v9H3z" />
      <path d="M14 9h4l3 3v3h-7z" />
      <circle cx="7" cy="18" r="1.6" />
      <circle cx="17.5" cy="18" r="1.6" />
    </>
  ),
  card: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="M3 10h18M7 15h4" />
    </>
  ),
  barChart: (
    <>
      <path d="M3 21h18" />
      <rect x="5" y="11" width="3" height="7" rx="0.5" />
      <rect x="10.5" y="6" width="3" height="12" rx="0.5" />
      <rect x="16" y="9" width="3" height="9" rx="0.5" />
    </>
  ),
  receipt: (
    <>
      <path d="M6 3h12v18l-2-1.5L14 21l-2-1.5L10 21l-2-1.5L6 21z" />
      <path d="M9 8h6M9 12h6" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="9" r="3" />
      <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
      <path d="M16 6.5a3 3 0 0 1 0 5.6" />
      <path d="M20.5 20a5.6 5.6 0 0 0-4-5.3" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </>
  ),
  lineChart: (
    <>
      <path d="M3 21h18" />
      <path d="M5 15l4-4 3 3 6-7" />
      <path d="M18 8h3v3" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-6 7-11a7 7 0 0 0-14 0c0 5 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  bolt: <path d="M13 2 4 14h7l-1 8 9-12h-7z" />,
};

// Map the legacy emoji values to the icon keys above.
export const emojiToIcon: Record<string, string> = {
  "🌐": "globe",
  "🏭": "building",
  "🚀": "rocket",
  "🛒": "cart",
  "🧠": "sparkleAI",
  "📱": "mobile",
  "🏬": "warehouse",
  "📦": "box",
  "🚚": "truck",
  "💳": "card",
  "📊": "barChart",
  "🧾": "receipt",
  "🎯": "target",
  "👥": "users",
  "👤": "user",
  "📈": "lineChart",
  "📍": "pin",
  "⚡": "bolt",
};
